<template>
  <BaseModal ref="modal" modal-classes="max-w-md mx-auto" @modal-after-leave="$emit('closed')">
    <template v-if="!data.id" #header>
      <span class="text-xs text-gray-700 uppercase tracking-wider">Δημιουργία σελιδας</span>
    </template>

    <template v-else #header>
      <span class="text-xs text-gray-700 uppercase tracking-wider">Τροποποιηση σελιδας</span>
      <h6 class="heading">
        {{ page.title }}
      </h6>
    </template>

    <template #default="modalProps">
      <BaseFetchData :action="fetchData">
        <template #default="fetchDataProps">
          <BaseVeeForm
            v-if="fetchDataProps.status.resolved"
            :action="submitForm"
            @success="
              () => {
                if (closeOnSuccess) {
                  modalProps.close();
                }
              }
            "
          >
            <template #default="formProps">
              <div class="space-y-8">
                <BaseFormTextFieldWithValidator
                  v-model="data.title"
                  :validator="{
                    name: 'title',
                    vid: 'title',
                    rules: {
                      required: true,
                    },
                  }"
                  :field="{
                    label: 'Title',
                    id: 'page_title',
                  }"
                  :disabled="formProps.isPending"
                />
                <BaseFormTextFieldWithValidator
                  v-model="data.url"
                  :validator="{
                    name: 'url',
                    vid: 'url',
                    rules: {
                      required: true,
                    },
                  }"
                  :field="{
                    label: 'Url',
                    inputType: 'url',
                    id: 'page_url',
                  }"
                  :disabled="formProps.isPending"
                />
                <BaseFormSelectFieldWithValidator
                  v-model="data.webpage_type"
                  v-bind="webpageTypeInputProps"
                />
                <BaseFormTextareaFieldWithValidator
                  v-model="data.description"
                  :validator="{
                    name: 'description',
                    vid: 'description',
                    rules: {
                      required: false,
                    },
                  }"
                  :field="{
                    label: 'Description',
                    id: 'page_description',
                  }"
                  :disabled="formProps.isPending"
                />
                <ValidationProvider name="tags" vid="tags" v-slot="{ errors }" slim>
                  <div class="space-y-2">
                    <BaseFormLabel> Tags </BaseFormLabel>
                    <VSelect
                      v-model="data.tags"
                      :options="tagOptions"
                      :reduce="(option) => option.id"
                      :get-option-label="getTagOptionLabel"
                      multiple
                      :disabled="formProps.isPending"
                      label="name"
                    />
                    <BaseFormInlineMessage v-if="errors.length" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </div>
                </ValidationProvider>
                <div class="flex items-center space-x-3">
                  <BaseButton primary :disabled="formProps.invalid || formProps.isPending">
                    <span v-if="!formProps.isPending">Submit</span>
                    <Loader v-else small inverse />
                  </BaseButton>
                  <BaseButton
                    ghost
                    type="button"
                    @click="modalProps.close"
                    :disabled="formProps.isPending"
                  >
                    Close
                  </BaseButton>
                </div>
              </div>
            </template>
          </BaseVeeForm>
        </template>
      </BaseFetchData>
    </template>
  </BaseModal>
</template>

<script>
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';
import { accountTagsClient } from '@/api/clients';

export default {
  name: 'ModalEdit',
  mixins: [veeValidateErrorsMixin],
  props: {
    accountId: {
      type: String,
      required: true,
    },
    page: {
      type: Object,
      default: () => ({}),
    },
    action: {
      type: Function,
      required: true,
    },
    closeOnSuccess: Boolean,
  },
  data: () => ({
    data: null,
    tagOptions: [],
  }),
  computed: {
    webpageTypeInputProps() {
      return {
        validator: {
          name: 'webpage type',
          vid: 'webpage_type',
          rules: { required: false },
        },
        field: {
          options: [
            { label: 'Landing page', value: 'landing_page' },
            { label: 'Thank you page', value: 'thank_you_page' },
            { label: 'Blog post', value: 'blog_post' },
          ],
          id: 'webpage_type',
          label: 'Webpage type',
        },
      };
    },
  },
  created() {
    this.data = {
      title: this.page?.title || '',
      url: this.page?.url || '',
      description: this.page?.description || '',
      webpage_type: this.page?.webpage_type || null,
      tags: this.getTagIds(this.page?.tags || []),
    };
  },
  methods: {
    fetchData() {
      return accountTagsClient
        .list(this.accountId, {
          filter: {
            taggable_by: ['pages'],
          },
          page_size: 500,
        })
        .then((response) => {
          this.tagOptions = response.data;
        });
    },
    submitForm() {
      return this.action(this.data);
    },
    getTagIds(tags) {
      if (!tags || !Array.isArray(tags) || tags.length === 0) {
        return [];
      }

      return tags.map((tag) => tag?.id || tag);
    },
    getTagOptionLabel({ name, category }) {
      return category ? `${category}/${name}` : name;
    },
  },
};
</script>
